export default "__VITE_ASSET__DzpCBJeu__"